import { render, staticRenderFns } from "./hbDetail.vue?vue&type=template&id=1c767ab6"
import script from "./hbDetail.vue?vue&type=script&lang=js"
export * from "./hbDetail.vue?vue&type=script&lang=js"
import style0 from "./hbDetail.vue?vue&type=style&index=0&id=1c767ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports